import React, { useState } from "react";
import { Alert } from "reactstrap";
import { LoadingButton } from "../../../../components/LoadingButton";
import { MissingInfoForm } from "../../../../missinginfo/MissingInfoForm";
import { api } from "../../../../util/api";
import { WizardContext } from "../../WizardContext";

export const MissingInfoFormScreen = ({ ...props }) => {
  const [_loading, setLoading] = useState(false);

  return (
    <WizardContext.Consumer>
      {({ dispatch, caseId, caseUrl, labTests, miInfoUrl, state, nextStepUrl }) => {
        const handleNext = async () => {
          setLoading(true);

          try {
            const response = await api.get(miInfoUrl);
            dispatch({
              type: "setAnswer",
              key: "missingInfoFields",
              value: response.data,
              doTransition: state?.answers?.miType === "lab" ? false : true,
            });
          } catch (err) {
            console.error(err);
          } finally {
            setLoading(false);
          }
        };

        return (
          <>
            <Alert color="info">Collect as much of the following information as possible</Alert>

            <MissingInfoForm
              caseId={caseId}
              caseUrl={caseUrl}
              labTests={labTests}
              saveButtonText="Save &amp; Continue"
              afterSave={handleNext}
              miFollowUpType={state?.answers?.miType}
              nextStepUrl={nextStepUrl}
            />
          </>
        );
      }}
    </WizardContext.Consumer>
  );
};
